module.exports = __webpack_public_path__ + "img/ic-user.7391dbae.svg";